import { getTokens } from '../../../../../auth/AuthState';
import API from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { CatalogOrderSet } from '../types';
import { useGlobalLoading } from '../../../../../context';

export interface GetAllCatalogOrderSetsPayload {
  tenancyId: number;
}

export const useGetAllCatalogOrderSets = () => {
  const { startLoading, stopLoading } = useGlobalLoading();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const [orderSetData, setOrderSetData] = useState<CatalogOrderSet[]>([]);

  const filterInvalidMedications = (data: unknown): CatalogOrderSet[] => {
    if (!Array.isArray(data)) return [];
    return (data as CatalogOrderSet[])
      .map((orderSet) => {
        const medications = Array.isArray((orderSet as any)?.medications)
          ? ((orderSet as any).medications as any[])
          : [];
        const validMedications = medications.filter((m) => Boolean(m?.details));
        return {
          ...(orderSet as any),
          medications: validMedications,
        } as CatalogOrderSet;
      })
      .filter((orderSet) => {
        const medications = Array.isArray((orderSet as any)?.medications)
          ? ((orderSet as any).medications as any[])
          : [];
        return medications.length > 0;
      });
  };

  const postGetAllCatalogOrderSets = async (
    payload: GetAllCatalogOrderSetsPayload,
  ) => {
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      startLoading();
      const { data } = await API.post(
        `getAllCatalogOrderSets`,
        { ...payload },
        options,
      );

      setOrderSetData(filterInvalidMedications(data?.data));
      stopLoading();
    } catch (error: any) {
      console.error('An error occurred during getAllCatalogOrderSets', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in getAllCatalogOrderSets',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postGetAllCatalogOrderSets,
    errorMessage,
    isLoading,
    orderSetData,
  };
};
